import Webpush from '../pages/profile/webpush/Webpush.vue';
import Footer from './components/footer/Footer.vue';
import Drawer from './components/drawer/Drawer.vue';
import Header from './components/header/Header.vue';

export default {
  data() {
    return {
      showMobileMenu: false,
      initialized: false,
    };
  },
  components: {
    Drawer,
    Header,
    Webpush,
    Footer,
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    extranet() {
      return this.$store.state.settings.extranet === true;
    },
    loading() {
      return this.$store.state.loading;
    },
    epsCartLength() {
      return this.$store.state.eps.cartLength;
    },
    layout() {
      return this.$store.state.settings.layout;
    },
    counters() {
      return this.$store.state.counters;
    },
    bgUrl() {
      return this.$store.state.settings.bgUrl;
    },
    news() {
      return this.$store.state.settings.news === true;
    },
    instructions() {
      return this.$store.state.settings.instructions === true;
    },
    sales() {
      return this.$store.state.settings.sales === true;
    },
    courses() {
      return this.$store.state.settings.courses === true;
    },
    tickets() {
      return this.$store.state.settings.module_tickets === true;
    },
    design() {
      return this.$store.state.settings.module_design === true;
    },
    isBannersOn() {
      return this.$store.state.settings.module_banners === true;
    },
    isShopOn() {
      return this.$store.state.settings.shop === true;
    },
    isBlocked() {
      return !!(
        this.$store.state.user && this.$store.state.user.blocked_at !== null
      );
    },
    isChecked() {
      return this.$store.state.user && this.$store.state.user.is_checked === 1;
    },
    user() {
      return this.$store.state.user;
    },
    showWebpushPopup() {
      return (
        'Notification' in window
        && this.$store.state.user
        && this.$store.state.settings.webpush === true
        && this.$store.state.webpush.webpushPopupOpened === true
        && this.$store.state.webpush.webpushFirebaseToken === null
        && this.$store.state.webpush.webpushDeclinedAt === null
      );
    },
    /** Верхнее меню */
    topMenuItems() {
      if (this.isAuthenticated && !this.isBlocked) {
        const menu = [
          {
            title: 'Призы',
            path: '/shop',
            icon: 'gift',
            showIcon: true,
            showTitle: true,
          },
        ];
        this.news
          && menu.push({
            title: 'Новости',
            path: '/news',
            icon: 'comment-dots',
            showIcon: true,
            showTitle: true,
          });
        this.instructions
          && menu.push({
            title: 'Баллы',
            path: '/instructions',
            icon: 'chart-bar',
            showIcon: true,
            showTitle: true,
          });
        this.courses
          && menu.push({
            title: 'Обучение (тесты)',
            path: '/courses',
            icon: 'user-graduate',
            showIcon: true,
            showTitle: true,
          });
        this.isShopOn
          && menu.push({
            title: 'Товары',
            path: '/shop',
            icon: 'shopping-cart',
            showIcon: true,
            showTitle: true,
          });
        return menu;
      }
      return [];
    },
    /** Левое мобильное меню в дровере */
    leftMenuItems() {
      let menu = [];
      const portfolioCnt = this.counters.portfolio?.status;
      const ordersCnt = this.counters.orders?.cnt;
      const ordersMsgCnt = this.counters.orders_msg?.cnt;
      const chatCnt = this.counters.chat?.cnt;
      const newsCnt = this.counters.news?.cnt;
      const managerChatCnt = this.counters.managerChat?.cnt;
      // const applicationsCnt = this.counters.applications?.cnt;
      const applicationsMsgCnt = this.counters.applications_msg?.cnt;

      if (this.isAuthenticated && !this.isBlocked) {
        if (!this.isChecked) {
          menu = [{ title: 'Мой профиль', path: '/profile', name: 'profile', icon: 'mdi-home' }];
        } else {
          menu = [
            { title: 'Главная', path: '/dashboard', name: 'dashboard', icon: 'mdi-home-outline' },
            {
              title: 'Портфолио',
              path: '/portfolio',
              name: '/portfolio',
              icon: 'mdi-image-multiple',
              cnt: portfolioCnt,
            },
            // { title: 'Мои работы', path: '/jobs', name: 'jobs', icon: 'mdi-domain' },
            {
              title: 'Новости',
              path: '/news',
              name: 'news',
              icon: 'mdi-newspaper',
              cnt: newsCnt,
            },
            {
              title: 'Конкурсы / Акции',
              path: '/actions',
              name: 'actions',
              icon: 'mdi-android-studio',
            },
            {
              title: 'Мои монтажи',
              path: '/sales/installation',
              name: 'sales',
              icon: 'mdi-android-studio',
            },
            {
              title: 'Гарантии',
              path: '/guarantees',
              name: 'guarantees',
              icon: 'mdi-android-studio',
            },
            {
              title: 'Расписание семинаров',
              path: '/seminars',
              name: 'seminars',
              icon: 'mdi-reorder-horizontal',
            },
            {
              title: 'Обучение (тесты)',
              path: '/courses',
              name: 'courses',
              icon: 'mdi-school-outline',
            },
            {
              title: 'Продукция ',
              remote: 'https://www.stout.ru/catalog/',
              icon: 'mdi-package-variant-closed',
            },
            {
              title: 'Где купить',
              path: '/markets',
              name: 'markets',
              icon: 'mdi-shopping-outline',
            },
            {
              title: 'Информация',
              path: '/information',
              name: 'information',
              icon: 'mdi-information-outline',
            },
            {
              title: 'ЧаВо',
              path: '/faq',
              name: 'faq',
              icon: 'mdi-frequently-asked-questions',
            },
            {
              title: 'Чат с инженером',
              path: '/manager-chat',
              name: 'managerChat',
              icon: 'mdi-forum-outline',
              cnt: managerChatCnt,
            },
            {
              title: 'Заявки на монтаж',
              path: '/applications',
              name: 'applications',
              icon: 'mdi-account-check-outline',
              cnt: ordersCnt,
              cnt_add: ordersMsgCnt,
              dop_class: 'with-message',
            },
          ];
          if (this.design) {
            menu.push({
              title: 'Заявки на проектирование',
              path: '/design/projecting',
              name: 'projecting',
              icon: 'mdi-account-check-outline',
              // eslint-disable-next-line
              // cnt: applicationsCnt,
              cnt_add: applicationsMsgCnt,
              dop_class: 'with-message',
            });
          }
          menu.push({
            title: 'Призы',
            path: '/prizes',
            name: 'prizes',
            icon: 'mdi-license',
          });
          this.tickets
            ? menu.push({
              title: 'Помощь',
              path: '/tickets',
              name: 'tickets',
              icon: 'mdi-help-circle-outline',
              cnt: chatCnt,
            })
            : menu.push({
              title: 'Помощь',
              path: '/feedback',
              name: 'feedback',
              icon: 'mdi-help-circle-outline',
              cnt: chatCnt,
            });
        }
      }
      return menu;
    },
  },
  methods: {
    async UserLogout() {
      await this.$store.dispatch('UserLogout');
      await this.$router.push('/');
    },
    ToggleMenu(action) {
      this.showMobileMenu = action;
    },
    CheckClick(e) {
      const { drawer } = this.$refs;
      if (drawer) {
        const withinBoundaries = e.composedPath().includes(drawer.$el);
        this.showMobileMenu = window.innerWidth <= 1024 && withinBoundaries;
      }
    },
  },
  async created() {
    try {
      await this.$store.dispatch('GetSettings');
      if (this.isAuthenticated) {
        await this.$store.dispatch('GetCounters');
      }
      setInterval(async () => {
        if (this.isAuthenticated) {
          await this.$store.dispatch('GetCounters');
        }
      }, 60000);
      await this.$store.commit('SetLoading', false);
      this.isBannersOn
        && (await this.$store.dispatch('banners/GetBannersList'));
    } finally {
      this.initialized = true;
    }
  },
  async mounted() {
    await this.$store.dispatch('app/SetSidebar', this.isAuthenticated);
  },
};
